<template>
  <div class="authenticationdocs">
    <v-app>
      <article>
        <p class="docs-logo"><img src="../../../common/assets/images/Logo_4iQ-DEEP_with_R_MAIN_gray.svg"></p>
        <p class="docs-headline">2FA Documentation</p>
        <v-divider></v-divider>
        <div class="auth-main-conatiner">
          <p><strong><span>How to setup 2FA .?</span></strong></p>
          <p>This guide will show you the steps you need to follow in order to add UIGateway Security on authentication apps.</p>
          <v-divider></v-divider>
          <p><strong><span>Setting up the Google Authenticator on the Phone:</span></strong></p>
          <ol>
            <li>Download the Google Authenticator application from <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank" rel="noopener">Google Play</a> or <a href="https://itunes.apple.com/ro/app/google-authenticator/id388497605" target="_blank" rel="noopener">AppStore</a> (or download the Microsoft Authenticator from <a href="https://www.microsoft.com/en-gb/p/authenticator/9wzdncrfj3rj" target="_blank" rel="noopener">Microsoft Store</a>) </li>
            <li>Open the application and touch the <em>Begin</em> button to start the configuration</li>
          </ol>
          <p><img src="../../../common/assets/images/googleauthenticator.png"></p>
          <p>3. Select the <em>Scan a barcode</em> option, which will prompt access to use the camera of your phone, and scan the QR Code from the <a href="#" target="_blank" rel="noopener">UIGateway login</a> page</p>
          <p><img src="../../../common/assets/images/googlescanbarcode.png"></p>
          <p>Please scan the barcode using your mobile authentication app</p>
          <p>Reference image : You will observe same page by providing credentials to login page</p>
          <p><img src="../../../common/assets/images/uigateway2fa_new.png"></p>
          <p>4. The account is now synced with the authenticator from the browser and is ready to be used</p>
          <p>5. Use the generated code to login into the <a href="#" target="_blank" rel="noopener">UIGateway</a></p>
          <v-divider></v-divider>
          <p><strong><span>Setting up google Authenticator on Google Chrome:</span></strong></p>
          <p><strong>Step 1</strong></p>
          <p>Click on: <a href="https://chrome.google.com/webstore/detail/authenticator/bhghoamapcdpbohphigoooaddinpkbai?hl=en" target="_blank">Download</a> and add the google Authenticator extension to the browser if asked to do so or click on the <em>Add to Chrome button &gt; Add extension</em></p>
          <p><img class="google-auth" src="../../../common/assets/images/googleauth.png"></p>
          <p><strong>Step 2</strong></p>
          <ol>
            <li>Now the extension is added to the browser</li>
            <li>Click on the extention and click scan QR code beside Pencil icon</li>
          </ol>
          <p><img src="../../../common/assets/images/scanqrcode.png" alt="" width="590" height="560"></p>
          <p>scan the QR code from<a href="#" target="_blank" rel="noopener">Login page</a>
          <p>Qr code is visible once credentials are given and click on sign in.</p>
          <v-divider></v-divider>
          <p><strong><span>2FA Backup Codes:</span></strong></p>
          <p>These are the codes used for login if user unable to access Google Authenticator app.</p>
          <p>Here you can use backup codes instead of Google Authenticator Six digits code to get logged in.</p>
          <p><img src="../../../common/assets/images/2FABackupCodeInput_new.png"></p>
          <v-divider></v-divider>
          <p><strong><span>How to retrieve 2FA Backup Codes:</span></strong></p>
          <p>A popup with backup codes will appear after user logged in for the first time</p>
          <p><img src="../../../common/assets/images/backupCodesPopup.png" class="backup-codes-popup"></p>
          <!-- <p>Also 2FA Backup codes are retrieved from user menu.</p> -->
          <!-- <p><img src="../../../common/assets/images/backupCodesInUserMenu_new.png" class="backup-codes-popup"></p> -->
          <v-divider></v-divider>
          <p class="docs-headline">All Done , 2FA setup is successful.</p>
          <v-divider></v-divider>
        </div>
      </article>
    </v-app>
  </div>
</template>
<script>
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
Vue.use(Vuetify);

export default {
  name: "authenticationdocs",
  data() {
    return {
      
    };
  },
};
</script>